type DayOfWeek = 'All' | 'Mon' | 'Tue' | 'Wed' | 'Thu' | 'Fri' | 'Sat' | 'Sun';
const daysOfWeek: Array<DayOfWeek> = ['All', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

interface Holiday {
  date: string;
  public: boolean;
  localName: string;
  name: string;
  countryCode: string;
  types: string[];
  weekday: {
    date: {
      name: string;
      number: number;
    };
  };
}

type DaySchedule = {
  startTime: string;
  endTime: string;
  checked: boolean;
};

type WeeklySchedule = {
  [day in DayOfWeek]: DaySchedule;
};

type ORSchedule = {
  [key: string]: WeeklySchedule;
};

type PeriodSchedule = {
  id: string;
  name: string;
  startDate: string;
  endDate: string;
  applyToAllORs: boolean;
  schedule: ORSchedule;
  holidays?: Array<{ date: string; name: string }>;
};

type HospitalSchedule = PeriodSchedule[];

interface OR {
  value: string;
}

type ORSchedulerPropsType = {
  periodId: string;
  OR: string | null;
  schedule: WeeklySchedule;
  hospitalDispatch: React.Dispatch<{ type: string; payload: any }>;
};

type TimeSlotControlsProps = {
  OR: string | null;
  periodId: string;
};

export type {
  DayOfWeek,
  DaySchedule,
  PeriodSchedule,
  WeeklySchedule,
  HospitalSchedule,
  OR,
  ORSchedule,
  ORSchedulerPropsType,
  TimeSlotControlsProps,
  Holiday,
};

export { daysOfWeek };
